(ns frontend.lp-portal.sub
  (:require
   [re-frame.core :as rf]))

(def portal-status-path [:lp-portal-status])
(def session-data-path [::lp-portal-session])
(def simulated-email-path (conj session-data-path :simulated-email))
(def simulate-processing-path [::processing-simulate-request])
(def current-account-email-path (conj session-data-path :email))
(def current-tenant-path (conj session-data-path :tenant))
(def session-role-path (conj session-data-path :role))
(def landing-page-all-lp-guests-path [::all-lp-guests])

(rf/reg-sub
 ::env
 (fn [db]
   (:env db)))

(rf/reg-sub
 ::db
 (fn [db]
   db))

(rf/reg-sub
 ::last-server-message
 (fn [db]
   (:last-server-message db)))

(def app-config-path [:app-config])

(def csrf-token-path [:csrf-token])

(rf/reg-sub
 ::app-config
 (fn [db]
   (get-in db app-config-path)))

(rf/reg-sub
 ::csrf-token
 (fn [db]
   (get-in db csrf-token-path)))

(def init-dispatch-path [:init-callback])

(rf/reg-sub
 ::lp-portal-role
 (fn [db]
   (get-in db session-role-path)))

(rf/reg-sub
 ::user-email
 (fn [db]
   (get-in db current-account-email-path)))

(rf/reg-sub
 ::simulated-email
 (fn [db]
   (get-in db simulated-email-path)))

(rf/reg-sub
 ::tenant
 (fn [db]
   (get-in db current-tenant-path)))

(rf/reg-sub
 ::admin?
 (fn [db]
   (= :role/admin (get-in db session-role-path))))

(rf/reg-sub
 ::landing-page-all-lp-guests-path
 (fn [db]
   (get-in db landing-page-all-lp-guests-path)))

(rf/reg-sub
 ::lp-portal-status
 (fn [db]
   (get-in db portal-status-path)))

(rf/reg-sub
 ::no-access-message
 (fn [db]
   (:no-access-message db)))

(rf/reg-sub
 ::view-args
 (fn [db]
   (:view-args db)))

(rf/reg-sub
 ::uploading-cover-image
 (fn [db]
   (:uploading-cover-image db)))

(rf/reg-sub
 ::uploading-attachment
 (fn [db]
   (:uploading-attachment db)))

(rf/reg-sub
 ::cover-image-url
 (fn [db]
   (:cover-image-url db)))
